var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{ref:"editor",tag:"component",attrs:{"mode":_vm.mode,"value":_vm.itemRevision,"view":_vm.view},on:{"update:view":function($event){_vm.view=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }